import Controller from "./sortableList.controller";
import template from "./sortableList.html";

const sortableList = {
  template,
  controller: Controller,
  bindings: {
    selected: "<",
    items: "=",
    resource: "@",
    title: "@",
    name: "@",
    eventName: "<",
    sortable: "@",
    permissionName: "@",
    hideActions: "<",
  },
};

export default sortableList;



// WEBPACK FOOTER //
// ./src/components/sortableList/sortableList.component.js